import get from 'lodash/get';

interface IObjectProjectsKeys {
    [key: string]: string;
  }

interface Projects extends IObjectProjectsKeys {
    'Rp': string;
    'Dp': string;
    'Ai': string;
  }

const projects: Projects = {
    'Rp': 'Résidence principale',
    'Dp': 'Ex Dispositif Pinel/LLI',
    'Ai': 'Autre investissement',
};



function formatProjects(value: string) {
    return get(projects, value, value);
}

export { projects, formatProjects };


